export default "__VITE_ASSET__wPN_PL7N__"